module.exports = __webpack_public_path__ + "static/media/44251e2e-422f-4e2b-952d-e66e66726145.b51283d7.JPG";